import { useEffect } from "react";
import { useAtom, type WritableAtom } from "jotai";
import { appStore } from "../store";
import dayjs from "dayjs";
import { _eventBus } from "../../../core/events/EventBus";
import { IRecoil } from "../../Types/Index";
import { addonFlowStartedAtom, addonsPassengerListAtom, alreadyAddonsLegPassengerAtom, alreadyAddonsLegPassengerTotalAtom, bookingLegWiseAddonsForCancelTripAtom, carriedOverAddonsAtom, changeDateCarryOverSnapshotAtom, confirmAddonsPassengerListAtom, manageAddonsNewConfirmedAddonsAtom, manageAddonsRemovedAddonsAtom, manageSeatingBaselineAddonsLegPassengerAtom, mealPreferencesResponseAtom, patchAddonsOnConfirmAtom, pendingRefundFulfillmentIdsAtom, refundOffersByFulfillmentIdAtom, selectedLegAddonsPriceAtom, showAddonsModalAtom } from "../AddonsAtoms";
import { contentDetailAtom } from "../CmsConfirmationContentAtom";
import { cmsAboutPassDetailAtom, cmsAccountBannerAtom, cmsMonthlyPassOfferResponseAtom, cmsOfferDetailAtom, cmsOfferListAtom, cmsSpecialFareOfferDetailResponseAtom, cmsSpecialFareOfferResponseAtom, cmsTravelPassOfferResponseAtom } from "../CMSOffersAtom";
import { activitiesSectorsAtom, citiesAtom, corporateFormSubmittedAtom, requestCorporateAccountDetailsAtom } from "../corporateAccountAtoms";
import { authLoadedStateAtom, calendarDayIntervalAtom, cmsProductFeatureListAtom, cmsServiceClassFeatureListAtom, contactCategoriesAtom, cookieConsentBannerVisibleAtom, cookieConsentGivenAtom, cookieManagementModalVisibleAtom, cookiePreferencesAtom, corporateAccountFlowStartedAtom, getAppBanner, inboundOfferIdAtom, inboundSearchStateAtom, initializedStateAtom, isAnonymousStateAtom, isAuthCheckCompleteStateAtom, isAuthenticatedStateAtom, isBookReturnJourneyAtom, isChangeDateStateAtom, isHyperFastStateAtom, isQuickExchangeStateAtom, outboundOfferIdAtom, quickExchangeTripDirectionAtom, searchStateAtom, searchStatePopupAtom, selectCorporateAccountFaqAtom, selectedDateRangeStateAtom, selectedMenuAtom, selectedRangeStateAtom, selectFaqAtom, selectFaqLoading, selectOsInfo, sliderStationFacilitiesDataStateAtom, tokenStateAtom, userProfileStateAtom } from "../atoms";
import { activeBookingTabAtom, autoSuggestionListAtom, bookedNextTripsAtom, bookedTripsAtom, bookingConfirmStatusAtom, bookedJourneyCommentAtom, journeyPlannerStateAtom, bookingRequestAtom, bookingResponseAtom, bookingResponseListAtom, bookingsListPaginationAtom, cancelBookingConfirmPopupFlagAtom, defaultActiveKeyForTripSummaryAtom, displayPassengerDataAtom, guestCheckoutBookingIdAtom, inboundProductCodeAtom, inboundSelectedChangeDateAtom, inboundSelectedDateAtom, isModalVisibleAtom, isPastBookingDetailsAtom, isRetrieveModalOpenAtom, isRoundTripInboundModalVisibleAtom, isRoundTripModalVisibleAtom, isShuttleChangeDateAtom, lastMonthAtom, mealResponseAtom, modificationNotAllowedBookingIdsAtom, originalPriceOfExchangedItemsInboundAtom, originalPriceOfExchangedItemsOutboundAtom, outboundProductCodeAtom, pendingBookingDataAtom, quickExchangeBookingResponseAtom, refundableAmountAtom, refundFeeAtom, refundOfferResponseAtom, repeatedBookingAtom, retrieveFormAtom, searchPopupDataAtom, selectedBookingForBookItAgainAtom, selectedBookReturnJourneyDateAtom, selectedChangeDateAtom, selectedInboundTrainStateAtom, SelectedOfferIdChangeDateAtom, selectedTripsDataAtom, bookedCommentsResponseAtom, showRetrieveBookingAtom, ticketOptionsAtom, journeyPlannerTrainTypeTabAtom, bookingPaymentDataAtom, seatingPreferencesAtom, appliedPassengerPassAtom, upcomingMultiBookingTripsAtom, pastMultiBookingTripsAtom } from "../BookingAtom";
import { calendarBestPriceAtom, calendarRangeBestPriceAtom, calendarStateAtom, dateSelectedFromCalendarAtom, isDateOfferCheckDoneAtom, markSelectedDateAsDisableAtom, markSelectedDateAsSoldOutAtom, offerCalendarBestPriceAtom, popularTripsPriceAtom, selectedDatePriceAtom } from "../CalendarAtom";
import { cmsPLaceDetailAtom, bannerListResponseAtom, destinationDetailAtom, destinationResponseAtom, newsDetailResponseAtom, newsListResponseAtom, routesResponseAtom, trustBuildersResponseAtom, usefulInformationAtom, cmsAppDownloadLinkResponseAtom, appDownloadLinkAtom, enhancedTripsResponseAtom, favouriteTripsForTodayResponseAtom, favouriteDeparturesForTodayResponseAtom, enhancedTripDetailAtom, popularTripsForHomePageAtom, bestPriceAvailableOriginsAtom, usefulInfoDetailAtom, departureFromTripsAtom, todayTrainFromTripsAtom, cmsStopsAtom, newsLoadedAtom, routesLoadedAtom, popularTripsLoadedAtom, popularDestinationsLoadedAtom } from "../CmsDestinationAtom";
import { countryCodesAtom } from "../CountryAtom";
import { fulfillmentResponseAtom } from "../FulfillmentResponse";
import {
  languageDropdownOpenAtom,
  languagesResponseAtom,
  localeLanguageAtom,
} from "../LanguagesAtom";
import { selectedTrainLegsAtom, tripLegsDetailsAtom } from "../legTrainAtom";
import { carRentalLocationsAtom, carRentalModeAtom, carRentalResultsStatusAtom, carRentalSearchStateAtom, carRentalV2SegmentsAtom, endToEndSelectedTripAtom, rideEstimatesAtom, rideHailingDisabledAtom, rideHailingModeAtom, rideLocationPickerAtom, rideResultsStatusAtom, rideSearchStateAtom, shuttleAddedAtom, shuttleAddRequestAtom, shuttleBusModeAtom, shuttleMinPriceCacheAtom, shuttleStopAvailabilityAtom, refundedShuttleOfferIdsAtom, shuttleOffersStatusAtom, shuttleSelectionAtom, shuttleStopsAtom, shuttleTripsAtom, nolCardModeAtom, nolSelectionAtom, nolAddedAtom } from "../EndToEndJourneyAtom";
import { networkDetailResponseAtom, networkMapStationInfoResponseAtom, networkMapStationResponseAtom } from "../NetworkMapStationsAtom";
import { privacyPolicyContentResponseAtom } from "../PrivacyPolicyAtom";
import { currentLocationAtom, fetchingFmlmViewInformationAtom, fmlmFavouriteLocationAtom, fmlmFilterAtom, fmlmJourneyResponseAtom, fmlmReverseGeoCodeLocationAtom, fmlmSubStationDropdownAtom, fmlmViewInformationAtom, fmlmViewOffersMapAtom, isDepartureDateChangedAtom, isTimerVisibleAtom, isFmlmFilterTimerModelOpenAtom, lastFmlmFetchOfferDateAtom, locationDataAtom, locationMapVisibleAtom, locationPermissionStateAtom, selectedFmlmJourneyAtom, selectedLocationAtom, selectedLocationDestinationAtom, selectedInboundFmlmJourneyAtom, isFmlmInboundTimeModalOpenAtom, allFmlmJourneyAtom } from "../LocationAtom";
import { accountActionAtom, accountProgressAtom, activeAccountActionAtom, bookingsSearchResponseAtom, experienceFieldsAtom, favoriteDepartureFieldsAtom, favoriteTripsForTodayFieldsAtom, generalFieldsAtom, isOtpVerifiedAtom, isPassengerDropdownOpenAtom, isPersonalInfoFormValidAtom, isPersonalInfoModifiedAtom, isSelectingDestinationAtom, isSelectingOriginAtom, manageIncludeWidgetsAtom, manageWidgetsAtom, multiBookingPreferenceBackToAtom, otpErrorAtom, personalizeExperienceActiveTabAtom, phoneVerificationResponseAtom, showInvoiceDetailsAtom, specialAssistancePrefAtom, subActiveAccountActionAtom, travelsDaysAtom } from "../MyAccount";
import { allPassengerPriceAndAgeGroupAtom, allPassengerPriceAndAgeGroupInBoundAtom, alreadyPaidInBoundAtom, alreadyPaidOutBoundAtom, availableDatesAtom, cancelBookingPreviousRouteAtom, customerLoyaltyTierRateAtom, earnExtraPointsAtom, earnPointsAtom, earnPointsInboundAtom, earnPointsOutboundAtom, earnPointsTotalAtom, exchangeOffersAtom, filterStateAtom, filterTrainsAtom, initialTrainClassSelectionAtom, isPremiumPrivacySeatingCheckedAtom, isShuttleTripAtom, isStandardPrivacySeatingCheckedAtom, loyaltyTiersAtom, offerAtom, offerPassTypeAtom, offersPageViewAtom, offersRequestAtom, openSearchModalAtom, originalTrainClassSelectionAtom, outboundShuttleOfferIdAtom, passBookingsAtom, passengerSpecificationsTypesAtom, passFormValuesAtom, passOfferResponseAtom, paymentInboundAtom, paymentInboundItemsDetailsAtom, paymentInboundRefundAtom, paymentOutboundAtom, paymentOutBoundItemsDetailsAtom, paymentOutboundRefundAtom, selectedBookingIdForBookReturnJourneyAtom, selectedBookingIdForCancelAtom, selectedBookingIdForDateChangeAtom, selectedBookingTripStatusAtom, selectedCmsPassOfferAtom, selectedDateAtom, selectedInboundTrainAtom, selectedOfferIdAtom, selectedOutboundTrainAtom, selectedServiceClassAtom, selectedPassBookingAtom, selectedPassengerForDateChangeAtom, selectedPassengerForDateChangeInBoundAtom, selectedPassengersInBoundAtom, selectedPassOfferAtom, selectedShuttleOfferIdAtom, selectedTrainStateAtom, startIndexDateSelectorAtom, testStringAtom, ticketTypeStateAtom, trainAtom, trainTypeAtom, tripDisableForCancelSelectionAtom, tripDisableForDateChangeSelectionAtom, upgradeInboundOffersAtom, upgradeOutboundOffersAtom, visibleTrainsAtom, selectedStandardPrivacySeatingInboundAtom, selectedPremiumPrivacySeatingOutboundAtom, selectedPremiumPrivacySeatingInboundAtom, selectedStandardPrivacySeatingOutboundAtom, selectedPassengersOutBoundAtom, loyaltyProgramResponseAtom, tiersConfigAtom } from "../OfferAtoms";
import { areAllPassengerDetailsCompleteAtom, changeTripAlreadyPaidAddonsAtom, checkoutUserDataAtom, customerContactStateAtom, passengerMappingAtom, passengerSeatCursorAtom, passengerStateAtom, passengerTypesStateAtom, savedPassengerDetailAtom, selectedPassengerForCancelAtom, selectedPassengerForCancelInBoundAtom, selectedPassengersAtom, selectedPassengersPerTypeStateAtom } from "../PassengerAtoms";
import { carLicensePlateAtom, checkoutPaymentSummaryAtom, paymentCardsAtom, paymentStateAtom, paymentSubmittingAtom, paymentSuccessModalAtom, saveCardAtom, termsAgreedAtom } from "../PaymentAtom";
import { coachLayoutResponseAtom, confirmedSeatsAtom, floorPlanIconsResponseAtom, initiallyAvailableSeatsAtom, isManageSeatingAtom, originalSeatsAtom, placeMapResponseAtom, seatSelectorOpenAtom, seatServiceClassAtom, seatTravelClassAtom, seatsChangedOnCheckoutAtom, selectedCoachAtom, selectedSeatsAtom, unavailableSeatsAtom } from "../SeatingAtom";
import { actionTypeAtom, activeTicketAtom, additionalFieldsAtom, lastVisitedPageForServiceRequestAtom, modifiedPassengerNameAtom, openActionModalAtom, openCommentAtom, saveServiceRequestResponseAtom, selectedCategoryAndSubCategoryAtom, selectedTripForServiceRequestAtom, serviceCategoriesAtom, serviceRequestFormDataAtom, serviceRequestModalAtom, serviceRequestTicketListAtom, submitRequestButtonDisabledAtom, subServiceCategoriesAtom } from "../ServiceRequestAtom";
import { inboundShuttleState, isAddShuttleAtom, outboundShuttleState, trainShuttleBookingAtom } from "../ShuttleAtom";
import { isAddShuttleFlowAtom, shuttleBookedOffersAtom } from "../ShuttleBookedOffersAtom";
import { selectedShuttlesAtom } from "../SelectedShuttlesAtom";
import { favoritesStateAtom, stopsResponseAtom, subStationDropdownAtom, updatedStopsAtom } from "../StopsAtoms";
import { termsofUseContentResponseAtom } from "../TermsOfUseAtom";
import {
  currentLegIndexTicketAtom,
  currentOfferIndexTicketAtom,
  currentPassengerTicketAtom,
  modalStateRequestInvoiceAtom,
  modalStateTicketAtom,
} from "../TicketAtom";
import {
  nextAndPreviousTrainAtom,
  selectedTripForBookItAgainAtom,
  tripOfferAtom,
} from "../TripAtom";
import { userDataAtom } from "../UsersAtom";
import { listOfAppliedVoucherAtom, voucherCodeAtom, voucherDataAtom, voucherDetailAtom, voucherErrorAtom } from "../VoucherAtom";
import {
  loyaltyProgramDataAtom,
  cmsAboutLoyaltyProgramResponseAtom,
  loyaltyCardHandleSelectActionAtom,
  customerTiersDataAtom,
} from "../LoyaltyProgramDataAtom";
import { isUpgradeToPremiumStateAtom } from "../UpgradePremiumAtom";
import { whitelistedAtoms, extendedExpiryAtoms } from "../WhitelistedAtoms"
import { journeyPlannerStationAtom } from "../CmsJourneyPlannerAtom";
import { cmsGroupBookingAtom } from "../CmsGroupBookingAtom";
import { isMultiBookingStateAtom, multiBookingChangeTrainOffersAtom, multiBookingFormValuesAtom, multiBookingOfferResponseAtom, multiBookingRefundSummaryAtom, multiBookingSelectedTrainsAtom, multiBookingTravelDatesAtom } from "../MultiBookingAtom";

import { trainScheduleDataAtom } from "../TrainScheduleDataAtom";

const bufferMap = {} as { [key: string]: unknown };
const atomValueCache = {} as { [key: string]: unknown };

/**
 * When true, the UPDATE_REC_STATE handler will skip persisting atoms to
 * localStorage.  This is set during logout to prevent microtask-scheduled
 * writes from re-populating localStorage after it has been cleared.
 */
let _suppressLocalStorageWrites = false;

export const suppressLocalStorageWrites = () => {
  _suppressLocalStorageWrites = true;
  // Safety net: re-enable after 10s in case redirect fails
  setTimeout(() => { _suppressLocalStorageWrites = false; }, 10000);
};

export const resetLocalStorageWrites = () => {
  _suppressLocalStorageWrites = false;
};

// Local storage utility functions
export const STORAGE_PREFIX = 'recoil_state_';

/**
 * Synchronously removes every `recoil_state_*` key from localStorage.
 * Unlike `clearAllWhitelistedAtomsFromStorage` this is not limited to
 * the whitelist -- it catches anything that was ever persisted.
 */
export const purgeAllRecoilStateFromLocalStorage = (): void => {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(STORAGE_PREFIX)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));
};
const STORAGE_EXPIRY_MS = 30 * 60 * 1000; // 30 minutes in milliseconds
const EXTENDED_STORAGE_EXPIRY_MS = 60 * 60 * 1000; // 1 hour in milliseconds

interface StorageData {
  value: unknown;
  timestamp: number;
  expiresAt: number;
}

// Dynamic date detection utility
const isISODateString = (value: string): boolean => {
  if (typeof value !== 'string') return false;

  // Check for ISO 8601 format patterns
  const isoPatterns = [
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/,          // 2025-08-25T15:34:05.420Z
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?[+-]\d{2}:\d{2}$/, // with timezone offset
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/,                       // without milliseconds
  ];

  const matchesPattern = isoPatterns.some(pattern => pattern.test(value));
  if (!matchesPattern) return false;

  // Validate it's actually a valid date
  const date = new Date(value);
  return !isNaN(date.getTime()) && date.toISOString().startsWith(value.substring(0, 10));
};

export const saveAtomToLocalStorage = (key: string, value: unknown) => {
  try {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    const now = Date.now();

    // Dynamic pre-process to convert ISO date strings to Dayjs objects
    const preprocessValue = (obj: any): any => {
      if (obj === null || obj === undefined) return obj;

      if (Array.isArray(obj)) {
        return obj.map(preprocessValue);
      }

      if (typeof obj === 'string' && isISODateString(obj)) {
        try {
          return dayjs(obj);
        } catch (e) {
          console.warn('Failed to convert ISO string to dayjs during save:', obj);
          return obj;
        }
      }

      if (obj && typeof obj === 'object' && !dayjs.isDayjs(obj) && !(obj instanceof Date)) {
        const processed: any = {};

        for (const [objKey, objVal] of Object.entries(obj)) {
          processed[objKey] = preprocessValue(objVal);
        }

        return processed;
      }

      return obj;
    };

    const preprocessedValue = preprocessValue(value);

    // Create storage data with expiration metadata
    const expiryMs = extendedExpiryAtoms.includes(key) ? EXTENDED_STORAGE_EXPIRY_MS : STORAGE_EXPIRY_MS;
    const storageData: StorageData = {
      value: preprocessedValue,
      timestamp: now,
      expiresAt: now + expiryMs
    };

    // Custom serializer to handle Dayjs objects and other special types
    const serializedValue = JSON.stringify(storageData, (key, val) => {
      // Handle Dayjs objects - check for dayjs specific properties
      if (val && typeof val === 'object' && (
        dayjs.isDayjs(val) ||
        (val.$L !== undefined && val.$d !== undefined) ||
        (val._isAMomentObject === true)
      )) {
        return {
          __type: 'dayjs',
          __value: val.toISOString()
        };
      }
      // Handle native Date objects
      if (val instanceof Date) {
        return {
          __type: 'date',
          __value: val.toISOString()
        };
      }
      return val;
    });

    localStorage.setItem(storageKey, serializedValue);
  } catch (error) {
    console.warn(`Failed to save ${key} to localStorage:`, error);
  }
};

export const loadAtomFromLocalStorage = <T>(key: string): T | null => {
  try {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    const stored = localStorage.getItem(storageKey);

    if (!stored) return null;

    // Custom deserializer to handle Dayjs objects and other special types
    const parsedValue = JSON.parse(stored, (key, val) => {
      // Handle Dayjs objects
      if (val && typeof val === 'object' && val.__type === 'dayjs') {
        return dayjs(val.__value);
      }
      // Handle native Date objects
      if (val && typeof val === 'object' && val.__type === 'date') {
        return new Date(val.__value);
      }
      return val;
    });

    // Check if the parsed value has the new storage format with expiration
    if (parsedValue && typeof parsedValue === 'object' && 'expiresAt' in parsedValue && 'value' in parsedValue) {
      const storageData = parsedValue as StorageData;
      const now = Date.now();

      // Check if the data has expired
      if (now > storageData.expiresAt) {
        // Data has expired, remove it from localStorage
        localStorage.removeItem(storageKey);
        return null;
      }

      // Data is still valid, return the actual value
      const actualValue = storageData.value;

      // Dynamic post-process to handle any ISO date strings that might have been missed
      const processDateStrings = (obj: any): any => {
        if (obj === null || obj === undefined) return obj;

        if (Array.isArray(obj)) {
          return obj.map(processDateStrings);
        }

        if (typeof obj === 'string' && isISODateString(obj)) {
          try {
            return dayjs(obj);
          } catch (e) {
            console.warn('Failed to convert ISO string to dayjs during load:', obj);
            return obj;
          }
        }

        if (obj && typeof obj === 'object' && !dayjs.isDayjs(obj) && !(obj instanceof Date)) {
          const processed: any = {};

          for (const [objKey, objVal] of Object.entries(obj)) {
            processed[objKey] = processDateStrings(objVal);
          }

          return processed;
        }

        return obj;
      };

      return processDateStrings(actualValue);
    } else {
      // Legacy format without expiration - treat as expired and remove
      localStorage.removeItem(storageKey);
      return null;
    }
  } catch (error) {
    console.warn(`Failed to load ${key} from localStorage:`, error);
    // If there's an error parsing, remove the corrupted data
    try {
      const storageKey = `${STORAGE_PREFIX}${key}`;
      localStorage.removeItem(storageKey);
    } catch (e) {
      // Ignore cleanup errors
    }
    return null;
  }
};

const removeFromLocalStorage = (key: string) => {
  try {
    const storageKey = `${STORAGE_PREFIX}${key}`;
    localStorage.removeItem(storageKey);
  } catch (error) {
    console.warn(`Failed to remove ${key} from localStorage:`, error);
  }
};

// O(1) membership check for the persistence whitelist (checked on every state
// write and every useRecState mount).
const whitelistedAtomSet = new Set(whitelistedAtoms);

// O(1) atom lookup. Built lazily on first use (the `atoms` array is defined
// further down in this module). Keeps the FIRST occurrence of a duplicated
// key to match the previous `atoms.find()` semantics.
let _atomsByKey: Map<string, (typeof atoms)[number]> | null = null;
function getAtomByKey(key: string) {
  if (!_atomsByKey) {
    _atomsByKey = new Map();
    for (const a of atoms) {
      if (!_atomsByKey.has(a.key)) _atomsByKey.set(a.key, a);
    }
  }
  return _atomsByKey.get(key);
}

// NOTE: This handler is registered before the atoms array is defined below.
// The Jotai store sync uses a lazy lookup so that `atoms` is resolved at call time.
_eventBus.on<IRecoil, void>({
  eventName: "UPDATE_REC_STATE",
  handler: async ({ data }) => {
    if (data) {
      bufferMap[data.key] = data.value;
      // Also update the cache to keep it in sync
      atomValueCache[data.key] = data.value;
      // Also update Jotai store
      const jotaiAtom = getAtomByKey(data.key);
      if (jotaiAtom) {
        appStore.set(jotaiAtom, data.value);
      }
      // Persist to localStorage only if the atom is whitelisted
      // and we are not in the middle of a logout (which clears storage).
      if (whitelistedAtomSet.has(data.key) && !_suppressLocalStorageWrites) {
        saveAtomToLocalStorage(data.key, data.value);
      }
    }
  },
});

const ATOMS = {
  endToEndSelectedTripAtom: endToEndSelectedTripAtom,
  rideHailingModeAtom: rideHailingModeAtom,
  rideSearchStateAtom: rideSearchStateAtom,
  rideEstimatesAtom: rideEstimatesAtom,
  rideResultsStatusAtom: rideResultsStatusAtom,
  rideLocationPickerAtom: rideLocationPickerAtom,
  rideHailingDisabledAtom: rideHailingDisabledAtom,
  carRentalModeAtom: carRentalModeAtom,
  carRentalSearchStateAtom: carRentalSearchStateAtom,
  carRentalLocationsAtom: carRentalLocationsAtom,
  carRentalResultsStatusAtom: carRentalResultsStatusAtom,
  carRentalV2SegmentsAtom: carRentalV2SegmentsAtom,
  shuttleBusModeAtom: shuttleBusModeAtom,
  shuttleSelectionAtom: shuttleSelectionAtom,
  shuttleStopsAtom: shuttleStopsAtom,
  shuttleTripsAtom: shuttleTripsAtom,
  shuttleOffersStatusAtom: shuttleOffersStatusAtom,
  shuttleMinPriceCacheAtom: shuttleMinPriceCacheAtom,
  shuttleStopAvailabilityAtom: shuttleStopAvailabilityAtom,
  refundedShuttleOfferIdsAtom: refundedShuttleOfferIdsAtom,
  shuttleAddedAtom: shuttleAddedAtom,
  shuttleAddRequestAtom: shuttleAddRequestAtom,
  nolCardModeAtom: nolCardModeAtom,
  nolSelectionAtom: nolSelectionAtom,
  nolAddedAtom: nolAddedAtom,
  appliedPassengerPassAtom: appliedPassengerPassAtom,
  passBookingsAtom: passBookingsAtom,
  multiBookingOfferResponseAtom: multiBookingOfferResponseAtom,
  multiBookingSelectedTrainsAtom: multiBookingSelectedTrainsAtom,
  multiBookingFormValuesAtom: multiBookingFormValuesAtom,
  multiBookingTravelDatesAtom: multiBookingTravelDatesAtom,
  multiBookingChangeTrainOffersAtom: multiBookingChangeTrainOffersAtom,
  newsLoadedAtom: newsLoadedAtom,
  routesLoadedAtom: routesLoadedAtom,
  popularTripsLoadedAtom: popularTripsLoadedAtom,
  popularDestinationsLoadedAtom: popularDestinationsLoadedAtom
} as const;

type RecoilAtomMap = {
  [K in keyof typeof ATOMS]: typeof ATOMS[K] extends WritableAtom<infer T, any, any> ? T : never;
};

export const atoms: ReadonlyArray<WritableAtom<any, [any], void> & { key: string; initialValue?: unknown }> = [
  ...Object.values(ATOMS), // Dynamically add atoms from ATOMS
  testStringAtom,
  quickExchangeBookingResponseAtom,
  exchangeOffersAtom,
  stopsResponseAtom,
  mealResponseAtom,
  ticketOptionsAtom,
  seatingPreferencesAtom,
  isAuthenticatedStateAtom,
  isAnonymousStateAtom,
  tokenStateAtom,
  userProfileStateAtom,
  isAuthCheckCompleteStateAtom,
  initializedStateAtom,
  passengerTypesStateAtom,
  searchStateAtom,
  searchStatePopupAtom,
  userDataAtom,
  favoritesStateAtom,
  searchPopupDataAtom,
  languagesResponseAtom,
  selectedDateRangeStateAtom,
  calendarDayIntervalAtom,
  accountActionAtom,
  selectedTrainStateAtom,
  isSelectingOriginAtom,
  isSelectingDestinationAtom,
  isPassengerDropdownOpenAtom,
  languageDropdownOpenAtom,
  localeLanguageAtom,
  offerAtom,
  offerPassTypeAtom,
  offersPageViewAtom,
  selectedCmsPassOfferAtom,
  selectedPassOfferAtom,
  passOfferResponseAtom,
  passFormValuesAtom,
  selectedPassBookingAtom,
  cmsAboutPassDetailAtom,
  cmsAccountBannerAtom,
  upgradeOutboundOffersAtom,
  upgradeInboundOffersAtom,
  openSearchModalAtom,
  trainTypeAtom,
  availableDatesAtom,
  offersRequestAtom,
  filterStateAtom,
  selectedServiceClassAtom,
  trainAtom,
  startIndexDateSelectorAtom,
  filterTrainsAtom,
  visibleTrainsAtom,
  selectedOutboundTrainAtom,
  selectedInboundTrainAtom,
  selectedOfferIdAtom,
  selectedShuttleOfferIdAtom,
  outboundShuttleOfferIdAtom,
  originalTrainClassSelectionAtom,
  initialTrainClassSelectionAtom,
  ticketTypeStateAtom,
  passengerSpecificationsTypesAtom,
  paymentOutboundAtom,
  paymentOutboundRefundAtom,
  paymentInboundAtom,
  paymentInboundRefundAtom,
  activeAccountActionAtom,
  countryCodesAtom,
  selectedMenuAtom,
  updatedStopsAtom,
  subStationDropdownAtom,
  showInvoiceDetailsAtom,
  isPersonalInfoModifiedAtom,
  isPersonalInfoFormValidAtom,
  outboundOfferIdAtom,
  inboundSearchStateAtom,
  inboundOfferIdAtom,
  bookingRequestAtom,
  bookingResponseAtom,
  authLoadedStateAtom,
  accountProgressAtom,
  passengerStateAtom,
  selectedPassengersPerTypeStateAtom,
  customerContactStateAtom,
  savedPassengerDetailAtom,
  voucherCodeAtom,
  voucherErrorAtom,
  listOfAppliedVoucherAtom,
  checkoutUserDataAtom,
  cookieConsentGivenAtom,
  cookieConsentBannerVisibleAtom,
  cookieManagementModalVisibleAtom,
  cookiePreferencesAtom,
  passengerMappingAtom,
  tripLegsDetailsAtom,
  areAllPassengerDetailsCompleteAtom,
  paymentStateAtom,
  carLicensePlateAtom,
  saveCardAtom,
  termsAgreedAtom,
  paymentSubmittingAtom,
  seatSelectorOpenAtom,
  selectedSeatsAtom,
  originalSeatsAtom,
  confirmedSeatsAtom,
  placeMapResponseAtom,
  locationPermissionStateAtom,
  coachLayoutResponseAtom,
  floorPlanIconsResponseAtom,
  seatServiceClassAtom,
  seatTravelClassAtom,
  selectedCoachAtom,
  unavailableSeatsAtom,
  seatsChangedOnCheckoutAtom,
  initiallyAvailableSeatsAtom,
  isAddShuttleAtom,
  outboundShuttleState,
  inboundShuttleState,
  selectedPassengerForCancelAtom,
  trainShuttleBookingAtom,
  shuttleBookedOffersAtom,
  selectedShuttlesAtom,
  bookedTripsAtom,
  upcomingMultiBookingTripsAtom,
  pastMultiBookingTripsAtom,
  isModalVisibleAtom,
  isRoundTripModalVisibleAtom,
  isRoundTripInboundModalVisibleAtom,
  calendarStateAtom,
  selectedTripForBookItAgainAtom,
  selectedPassengerForCancelInBoundAtom,
  fulfillmentResponseAtom,
  selectedTrainLegsAtom,
  tripOfferAtom,
  passengerSeatCursorAtom,
  sliderStationFacilitiesDataStateAtom,
  allPassengerPriceAndAgeGroupAtom,
  bookedNextTripsAtom,
  activeBookingTabAtom,
  bookingsListPaginationAtom,
  allPassengerPriceAndAgeGroupInBoundAtom,
  currentPassengerTicketAtom,
  currentOfferIndexTicketAtom,
  currentLegIndexTicketAtom,
  modalStateTicketAtom,
  modalStateRequestInvoiceAtom,
  selectedInboundTrainStateAtom,
  checkoutPaymentSummaryAtom,
  nextAndPreviousTrainAtom,
  lastMonthAtom,
  retrieveFormAtom,
  isPastBookingDetailsAtom,
  bookingConfirmStatusAtom,
  isHyperFastStateAtom,
  isQuickExchangeStateAtom,
  bookingConfirmStatusAtom,
  checkoutPaymentSummaryAtom,
  modalStateTicketAtom,
  selectedTrainStateAtom,
  selectedPassengerForCancelInBoundAtom,
  selectedDateAtom,
  inboundSelectedDateAtom,
  selectedPassengersAtom,
  selectedBookingIdForCancelAtom,
  cancelBookingPreviousRouteAtom,
  tripDisableForCancelSelectionAtom,
  selectedBookingTripStatusAtom,
  selectedPassengersOutBoundAtom,
  selectedPassengersInBoundAtom,
  paymentOutBoundItemsDetailsAtom,
  cancelBookingConfirmPopupFlagAtom,
  paymentInboundItemsDetailsAtom,
  alreadyPaidOutBoundAtom,
  alreadyPaidInBoundAtom,
  repeatedBookingAtom,
  calendarBestPriceAtom,
  repeatedBookingAtom,
  alreadyPaidInBoundAtom,
  selectedPassengerForDateChangeAtom,
  selectedPassengerForDateChangeInBoundAtom,
  selectedBookingIdForDateChangeAtom,
  tripDisableForDateChangeSelectionAtom,
  outboundProductCodeAtom,
  inboundProductCodeAtom,
  isShuttleChangeDateAtom,
  inboundSelectedChangeDateAtom,
  selectedChangeDateAtom,
  SelectedOfferIdChangeDateAtom,
  selectedRangeStateAtom,
  isChangeDateStateAtom,
  displayPassengerDataAtom,
  isRetrieveModalOpenAtom,
  selectedTripsDataAtom,
  showRetrieveBookingAtom,
  modificationNotAllowedBookingIdsAtom,
  autoSuggestionListAtom,
  offerCalendarBestPriceAtom,
  markSelectedDateAsDisableAtom,
  dateSelectedFromCalendarAtom,
  selectedDatePriceAtom,
  isDateOfferCheckDoneAtom,
  markSelectedDateAsSoldOutAtom,
  calendarRangeBestPriceAtom,
  locationMapVisibleAtom,
  locationDataAtom,
  selectedLocationAtom,
  fmlmSubStationDropdownAtom,
  selectedLocationDestinationAtom,
  fmlmReverseGeoCodeLocationAtom,
  currentLocationAtom,
  fetchingFmlmViewInformationAtom,
  fmlmViewInformationAtom,
  fmlmViewOffersMapAtom,
  lastFmlmFetchOfferDateAtom,
  fmlmFilterAtom,
  isDepartureDateChangedAtom,
  selectedFmlmJourneyAtom,
  selectedInboundFmlmJourneyAtom,
  isTimerVisibleAtom,
  isFmlmFilterTimerModelOpenAtom,
  isFmlmInboundTimeModalOpenAtom,
  pendingBookingDataAtom,
  guestCheckoutBookingIdAtom,
  selectedBookingForBookItAgainAtom,
  originalPriceOfExchangedItemsOutboundAtom,
  originalPriceOfExchangedItemsInboundAtom,
  refundOfferResponseAtom,
  refundFeeAtom,
  refundableAmountAtom,
  getAppBanner,
  selectOsInfo,
  selectFaqAtom,
  contactCategoriesAtom,
  selectFaqLoading,
  fmlmFavouriteLocationAtom,
  isOtpVerifiedAtom,
  phoneVerificationResponseAtom,
  otpErrorAtom,
  fmlmFavouriteLocationAtom,
  isManageSeatingAtom,
  fmlmJourneyResponseAtom,
  paymentSuccessModalAtom,
  selectedTripForServiceRequestAtom,
  selectedCategoryAndSubCategoryAtom,
  serviceCategoriesAtom,
  subServiceCategoriesAtom,
  serviceRequestFormDataAtom,
  submitRequestButtonDisabledAtom,
  saveServiceRequestResponseAtom,
  serviceRequestModalAtom,
  destinationResponseAtom,
  cmsOfferListAtom,
  cmsOfferDetailAtom,
  cmsMonthlyPassOfferResponseAtom,
  cmsTravelPassOfferResponseAtom,
  cmsSpecialFareOfferResponseAtom,
  cmsSpecialFareOfferDetailResponseAtom,
  cmsPLaceDetailAtom,
  cmsAppDownloadLinkResponseAtom,
  cmsServiceClassFeatureListAtom,
  cmsProductFeatureListAtom,
  appDownloadLinkAtom,
  destinationDetailAtom,
  termsofUseContentResponseAtom,
  privacyPolicyContentResponseAtom,
  usefulInformationAtom,
  routesResponseAtom,
  trustBuildersResponseAtom,
  newsListResponseAtom,
  newsDetailResponseAtom,
  bannerListResponseAtom,
  serviceRequestTicketListAtom,
  openActionModalAtom,
  actionTypeAtom,
  openCommentAtom,
  bookingResponseListAtom,
  activeTicketAtom,
  activitiesSectorsAtom,
  citiesAtom,
  requestCorporateAccountDetailsAtom,
  corporateFormSubmittedAtom,
  selectCorporateAccountFaqAtom,
  corporateAccountFlowStartedAtom,
  networkMapStationResponseAtom,
  networkDetailResponseAtom,
  networkMapStationInfoResponseAtom,
  journeyPlannerStationAtom,
  popularTripsPriceAtom,
  contentDetailAtom,
  defaultActiveKeyForTripSummaryAtom,
  lastVisitedPageForServiceRequestAtom,
  isUpgradeToPremiumStateAtom,
  citiesAtom,
  requestCorporateAccountDetailsAtom,
  corporateFormSubmittedAtom,
  selectCorporateAccountFaqAtom,
  corporateAccountFlowStartedAtom,
  trustBuildersResponseAtom,
  networkMapStationResponseAtom,
  networkDetailResponseAtom,
  popularTripsPriceAtom,
  mealPreferencesResponseAtom,
  showAddonsModalAtom,
  addonsPassengerListAtom,
  selectedLegAddonsPriceAtom,
  confirmAddonsPassengerListAtom,
  alreadyAddonsLegPassengerAtom,
  changeTripAlreadyPaidAddonsAtom,
  quickExchangeTripDirectionAtom,
  alreadyAddonsLegPassengerTotalAtom,
  manageAddonsNewConfirmedAddonsAtom,
  manageAddonsRemovedAddonsAtom,
  patchAddonsOnConfirmAtom,
  bookingLegWiseAddonsForCancelTripAtom,
  addonFlowStartedAtom,
  carriedOverAddonsAtom,
  changeDateCarryOverSnapshotAtom,
  manageSeatingBaselineAddonsLegPassengerAtom,
  pendingRefundFulfillmentIdsAtom,
  refundOffersByFulfillmentIdAtom,
  isUpgradeToPremiumStateAtom,
  additionalFieldsAtom,
  modifiedPassengerNameAtom,
  selectedBookingIdForBookReturnJourneyAtom,
  selectedBookReturnJourneyDateAtom,
  isBookReturnJourneyAtom,
  bookedCommentsResponseAtom,
  bookedJourneyCommentAtom,
  journeyPlannerStateAtom,
  journeyPlannerTrainTypeTabAtom,
  allFmlmJourneyAtom,
  manageIncludeWidgetsAtom,
  manageWidgetsAtom,
  experienceFieldsAtom,
  favoriteDepartureFieldsAtom,
  favoriteTripsForTodayFieldsAtom,
  multiBookingPreferenceBackToAtom,
  subActiveAccountActionAtom,
  bookingsSearchResponseAtom,
  personalizeExperienceActiveTabAtom,
  generalFieldsAtom,
  specialAssistancePrefAtom,
  travelsDaysAtom,
  enhancedTripsResponseAtom,
  voucherDataAtom,
  isShuttleTripAtom,
  bookingPaymentDataAtom,
  favouriteTripsForTodayResponseAtom,
  favouriteDeparturesForTodayResponseAtom,
  enhancedTripDetailAtom,
  popularTripsForHomePageAtom,
  bestPriceAvailableOriginsAtom,
  usefulInfoDetailAtom,
  departureFromTripsAtom,
  todayTrainFromTripsAtom,
  cmsStopsAtom,
  isAddShuttleFlowAtom,
  earnPointsAtom,
  earnExtraPointsAtom,
  earnPointsTotalAtom,
  earnPointsOutboundAtom,
  earnPointsInboundAtom,
  loyaltyTiersAtom,
  customerLoyaltyTierRateAtom,
  cmsGroupBookingAtom,
  isStandardPrivacySeatingCheckedAtom,
  isPremiumPrivacySeatingCheckedAtom,
  selectedStandardPrivacySeatingOutboundAtom,
  selectedStandardPrivacySeatingInboundAtom,
  selectedPremiumPrivacySeatingOutboundAtom,
  selectedPremiumPrivacySeatingInboundAtom,
  loyaltyProgramResponseAtom,
  paymentCardsAtom,
  voucherDetailAtom,
  isMultiBookingStateAtom,
  multiBookingRefundSummaryAtom,
  trainScheduleDataAtom,
  loyaltyProgramDataAtom,
  cmsAboutLoyaltyProgramResponseAtom,
  loyaltyCardHandleSelectActionAtom,
  customerTiersDataAtom
];

export type TAtomList =
  | keyof RecoilAtomMap
  | "testStringAtom"
  | "addonFlowStartedAtom"
  | "bookingLegWiseAddonsForCancelTripAtom"
  | "manageAddonsNewConfirmedAddonsAtom"
  | "manageAddonsRemovedAddonsAtom"
  | "patchAddonsOnConfirmAtom"
  | "modifiedPassengerNameAtom"
  | "additionalFieldsAtom"
  | "sliderStationFacilitiesDataStateAtom"
  | "quickExchangeTripDirectionAtom"
  | "alreadyAddonsLegPassengerTotalAtom"
  | "lastVisitedPageForServiceRequestAtom"
  | "changeTripAlreadyPaidAddonsAtom"
  | "alreadyAddonsLegPassengerAtom"
  | "changeDateCarryOverSnapshotAtom"
  | "manageSeatingBaselineAddonsLegPassengerAtom"
  | "pendingRefundFulfillmentIdsAtom"
  | "refundOffersByFulfillmentIdAtom"
  | "initialTrainClassSelectionAtom"
  | "confirmAddonsPassengerListAtom"
  | "selectedLegAddonsPriceAtom"
  | "addonsPassengerListAtom"
  | "showAddonsModalAtom"
  | "mealPreferencesResponseAtom"
  | "selectCorporateAccountFaqAtom"
  | "corporateAccountFlowStartedAtom"
  | "activeTicketAtom"
  | "bookingResponseListAtom"
  | "actionTypeAtom"
  | "openCommentAtom"
  | "openActionModalAtom"
  | "serviceRequestTicketListAtom"
  | "selectedTripForServiceRequestAtom"
  | "serviceRequestModalAtom"
  | "saveServiceRequestResponseAtom"
  | "submitRequestButtonDisabledAtom"
  | "serviceRequestFormDataAtom"
  | "selectedCategoryAndSubCategoryAtom"
  | "serviceCategoriesAtom"
  | "subServiceCategoriesAtom"
  | "guestCheckoutBookingIdAtom"
  | "markSelectedDateAsSoldOutAtom"
  | "isDateOfferCheckDoneAtom"
  | "selectedDatePriceAtom"
  | "dateSelectedFromCalendarAtom"
  | "markSelectedDateAsDisableAtom"
  | "autoSuggestionListAtom"
  | "calendarBestPriceAtom"
  | "requestCorporateAccountDetailsAtom"
  | "citiesAtom"
  | "nextAndPreviousTrainAtom"
  | "tripOfferAtom"
  | "stopsResponseAtom"
  | "mealResponseAtom"
  | "ticketOptionsAtom"
  | "seatingPreferencesAtom"
  | "quickExchangeBookingResponseAtom"
  | "isAuthenticatedStateAtom"
  | "isAnonymousStateAtom"
  | "tokenStateAtom"
  | "userProfileStateAtom"
  | "isAuthCheckCompleteStateAtom"
  | "initializedStateAtom"
  | "authLoadedStateAtom"
  | "passengerTypesStateAtom"
  | "searchStateAtom"
  | "selectedTripForBookItAgainAtom"
  | "searchStatePopupAtom"
  | "userDataAtom"
  | "favoritesStateAtom"
  | "searchPopupDataAtom"
  | "languagesResponseAtom"
  | "selectedDateRangeStateAtom"
  | "calendarDayIntervalAtom"
  | "accountActionAtom"
  | "isSelectingOriginAtom"
  | "isSelectingDestinationAtom"
  | "isPassengerDropdownOpenAtom"
  | "languageDropdownOpenAtom"
  | "localeLanguageAtom"
  | "offerAtom"
  | "offerPassTypeAtom"
  | "offersPageViewAtom"
  | "selectedCmsPassOfferAtom"
  | "selectedPassOfferAtom"
  | "passOfferResponseAtom"
  | "passFormValuesAtom"
  | "selectedPassBookingAtom"
  | "cmsAboutPassDetailAtom"
  | "cmsAccountBannerAtom"
  | "openSearchModalAtom"
  | "upgradeOutboundOffersAtom"
  | "upgradeInboundOffersAtom"
  | "trainTypeAtom"
  | "availableDatesAtom"
  | "offersRequestAtom"
  | "filterStateAtom"
  | "selectedServiceClassAtom"
  | "trainAtom"
  | "startIndexDateSelectorAtom"
  | "filterTrainsAtom"
  | "visibleTrainsAtom"
  | "selectedOutboundTrainAtom"
  | "selectedInboundTrainAtom"
  | "selectedOfferIdAtom"
  | "originalTrainClassSelectionAtom"
  | "ticketTypeStateAtom"
  | "passengerSpecificationsTypesAtom"
  | "paymentOutboundAtom"
  | "paymentOutboundRefundAtom"
  | "paymentInboundAtom"
  | "paymentInboundRefundAtom"
  | "selectedShuttleOfferIdAtom"
  | "activeAccountActionAtom"
  | "countryCodesAtom"
  | "selectedMenuAtom"
  | "updatedStopsAtom"
  | "subStationDropdownAtom"
  | "showInvoiceDetailsAtom"
  | "isPersonalInfoModifiedAtom"
  | "isPersonalInfoFormValidAtom"
  | "outboundOfferIdAtom"
  | "inboundSearchStateAtom"
  | "inboundOfferIdAtom"
  | "bookingRequestAtom"
  | "bookingResponseAtom"
  | "accountProgressAtom"
  | "passengerStateAtom"
  | "selectedPassengersPerTypeStateAtom"
  | "customerContactStateAtom"
  | "savedPassengerDetailAtom"
  | "locationPermissionStateAtom"
  | "voucherCodeAtom"
  | "voucherErrorAtom"
  | "listOfAppliedVoucherAtom"
  | "checkoutUserDataAtom"
  | "passengerMappingAtom"
  | "tripLegsDetailsAtom"
  | "areAllPassengerDetailsCompleteAtom"
  | "paymentStateAtom"
  | "carLicensePlateAtom"
  | "saveCardAtom"
  | "termsAgreedAtom"
  | "paymentSubmittingAtom"
  | "seatSelectorOpenAtom"
  | "selectedSeatsAtom"
  | "placeMapResponseAtom"
  | "coachLayoutResponseAtom"
  | "floorPlanIconsResponseAtom"
  | "seatServiceClassAtom"
  | "seatTravelClassAtom"
  | "selectedCoachAtom"
  | "unavailableSeatsAtom"
  | "seatsChangedOnCheckoutAtom"
  | "initiallyAvailableSeatsAtom"
  | "isAddShuttleAtom"
  | "outboundShuttleState"
  | "inboundShuttleState"
  | "selectedPassengerForCancelAtom"
  | "bookedTripsAtom"
  | "upcomingMultiBookingTripsAtom"
  | "pastMultiBookingTripsAtom"
  | "isModalVisibleAtom"
  | "isRoundTripModalVisibleAtom"
  | "calendarStateAtom"
  | "fulfillmentResponseAtom"
  | "selectedTrainLegsAtom"
  | "passengerSeatCursorAtom"
  | "bookedNextTripsAtom"
  | "activeBookingTabAtom"
  | "bookingsListPaginationAtom"
  | "currentPassengerTicketAtom"
  | "currentOfferIndexTicketAtom"
  | "currentLegIndexTicketAtom"
  | "modalStateRequestInvoiceAtom"
  | "outboundShuttleOfferIdAtom"
  | "selectedInboundShuttleOfferIdAtom"
  | "inboundSelectedDateAtom"
  | "selectedInboundTrainStateAtom"
  | "lastMonthAtom"
  | "retrieveFormAtom"
  | "isPastBookingDetailsAtom"
  | "isHyperFastStateAtom"
  | "isQuickExchangeStateAtom"
  | "bookingConfirmStatusAtom"
  | "checkoutPaymentSummaryAtom"
  | "isRoundTripInboundModalVisibleAtom"
  | "modalStateTicketAtom"
  | "trainShuttleBookingAtom"
  | "selectedTrainStateAtom"
  | "selectedPassengerForCancelInBoundAtom"
  | "selectedDateAtom"
  | "selectedPassengersAtom"
  | "selectedBookingIdForCancelAtom"
  | "cancelBookingPreviousRouteAtom"
  | "allPassengerPriceAndAgeGroupAtom"
  | "allPassengerPriceAndAgeGroupInBoundAtom"
  | "tripDisableForCancelSelectionAtom"
  | "selectedBookingTripStatusAtom"
  | "selectedPassengersOutBoundAtom"
  | "selectedPassengersInBoundAtom"
  | "paymentOutBoundItemsDetailsAtom"
  | "cancelBookingConfirmPopupFlagAtom"
  | "paymentInboundItemsDetailsAtom"
  | "alreadyPaidOutBoundAtom"
  | "repeatedBookingAtom"
  | "exchangeOffersAtom"
  | "alreadyPaidInBoundAtom"
  | "selectedPassengerForDateChangeAtom"
  | "selectedPassengerForDateChangeInBoundAtom"
  | "selectedBookingIdForDateChangeAtom"
  | "tripDisableForDateChangeSelectionAtom"
  | "outboundProductCodeAtom"
  | "inboundProductCodeAtom"
  | "isShuttleChangeDateAtom"
  | "inboundSelectedChangeDateAtom"
  | "selectedChangeDateAtom"
  | "SelectedOfferIdChangeDateAtom"
  | "selectedRangeStateAtom"
  | "isChangeDateStateAtom"
  | "displayPassengerDataAtom"
  | "isRetrieveModalOpenAtom"
  | "selectedTripsDataAtom"
  | "showRetrieveBookingAtom"
  | "modificationNotAllowedBookingIdsAtom"
  | "calendarRangeBestPriceAtom"
  | "locationMapVisibleAtom"
  | "locationDataAtom"
  | "selectedLocationAtom"
  | "fmlmSubStationDropdownAtom"
  | "selectedLocationDestinationAtom"
  | "fmlmReverseGeoCodeLocationAtom"
  | "currentLocationAtom"
  | "fetchingFmlmViewInformationAtom"
  | "fmlmViewInformationAtom"
  | "fmlmViewOffersMapAtom"
  | "lastFmlmFetchOfferDateAtom"
  | "fmlmFilterAtom"
  | "isDepartureDateChangedAtom"
  | "selectedFmlmJourneyAtom"
  | "selectedInboundFmlmJourneyAtom"
  | "isTimerVisibleAtom"
  | "isFmlmFilterTimerModelOpenAtom"
  | "isFmlmInboundTimeModalOpenAtom"
  | "pendingBookingDataAtom"
  | "selectedBookingForBookItAgainAtom"
  | "originalPriceOfExchangedItemsOutboundAtom"
  | "getAppBanner"
  | "selectOsInfo"
  | "selectFaqAtom"
  | "contactCategoriesAtom"
  | "selectFaqLoading"
  | "offerCalendarBestPriceAtom"
  | "isOtpVerifiedAtom"
  | "phoneVerificationResponseAtom"
  | "otpErrorAtom"
  | "fmlmFavouriteLocationAtom"
  | "originalPriceOfExchangedItemsInboundAtom"
  | "refundOfferResponseAtom"
  | "refundFeeAtom"
  | "refundableAmountAtom"
  | "isManageSeatingAtom"
  | "originalSeatsAtom"
  | "confirmedSeatsAtom"
  | "fmlmJourneyResponseAtom"
  | "paymentSuccessModalAtom"
  | "destinationResponseAtom"
  | "cmsOfferListAtom"
  | "cmsOfferDetailAtom"
  | "cmsMonthlyPassOfferResponseAtom"
  | "cmsTravelPassOfferResponseAtom"
  | "cmsSpecialFareOfferResponseAtom"
  | "cmsSpecialFareOfferDetailResponseAtom"
  | "cmsPLaceDetailAtom"
  | "cmsAppDownloadLinkResponseAtom"
  | "cmsServiceClassFeatureListAtom"
  | "cmsProductFeatureListAtom"
  | "appDownloadLinkAtom"
  | "destinationDetailAtom"
  | "usefulInformationAtom"
  | "routesResponseAtom"
  | "trustBuildersResponseAtom"
  | "newsListResponseAtom"
  | "newsDetailResponseAtom"
  | "bannerListResponseAtom"
  | "termsofUseContentResponseAtom"
  | "privacyPolicyContentResponseAtom"
  | "cookieConsentGivenAtom"
  | "cookieConsentBannerVisibleAtom"
  | "cookieManagementModalVisibleAtom"
  | "cookiePreferencesAtom"
  | "activitiesSectorsAtom"
  | "corporateFormSubmittedAtom"
  | "networkMapStationResponseAtom"
  | "networkDetailResponseAtom"
  | "networkMapStationInfoResponseAtom"
  | "journeyPlannerStationAtom"
  | "popularTripsPriceAtom"
  | "contentDetailAtom"
  | "defaultActiveKeyForTripSummaryAtom"
  | "isUpgradeToPremiumStateAtom"
  | "activitiesSectorsAtom"
  | "corporateFormSubmittedAtom"
  | "sliderStationFacilitiesDataStateAtom"
  | "selectedBookingIdForBookReturnJourneyAtom"
  | "selectedBookReturnJourneyDateAtom"
  | "isBookReturnJourneyAtom"
  | "bookedCommentsResponseAtom"
  | "bookedJourneyCommentAtom"
  | "journeyPlannerStateAtom"
  | "journeyPlannerTrainTypeTabAtom"
  | "allFmlmJourneyAtom"
  | "manageIncludeWidgetsAtom"
  | "manageWidgetsAtom"
  | "experienceFieldsAtom"
  | "favoriteDepartureFieldsAtom"
  | "favoriteTripsForTodayFieldsAtom"
  | "multiBookingPreferenceBackToAtom"
  | "subActiveAccountActionAtom"
  | "bookingsSearchResponseAtom"
  | "personalizeExperienceActiveTabAtom"
  | "generalFieldsAtom"
  | "specialAssistancePrefAtom"
  | "travelsDaysAtom"
  | "enhancedTripsResponseAtom"
  | "voucherDataAtom"
  | "isShuttleTripAtom"
  | "bookingPaymentDataAtom"
  | "favouriteTripsForTodayResponseAtom"
  | "favouriteDeparturesForTodayResponseAtom"
  | "enhancedTripDetailAtom"
  | "popularTripsForHomePageAtom"
  | "bestPriceAvailableOriginsAtom"
  | "usefulInfoDetailAtom"
  | "departureFromTripsAtom"
  | "todayTrainFromTripsAtom"
  | "cmsStopsAtom"
  | "shuttleBookedOffersAtom"
  | "selectedShuttlesAtom"
  | "isAddShuttleFlowAtom"
  | "earnPointsAtom"
  | "earnExtraPointsAtom"
  | "earnPointsTotalAtom"
  | "earnPointsOutboundAtom"
  | "earnPointsInboundAtom"
  | "loyaltyTiersAtom"
  | "customerLoyaltyTierRateAtom"
  | "cmsGroupBookingAtom"
  | "isStandardPrivacySeatingCheckedAtom"
  | "isPremiumPrivacySeatingCheckedAtom"
  | "selectedStandardPrivacySeatingOutboundAtom"
  | "selectedStandardPrivacySeatingInboundAtom"
  | "selectedPremiumPrivacySeatingOutboundAtom"
  | "selectedPremiumPrivacySeatingInboundAtom"
  | "loyaltyProgramResponseAtom"
  | "tiersConfigAtom"
  | "paymentCardsAtom"
  | "voucherDetailAtom"
  | "isMultiBookingStateAtom"
  | "multiBookingRefundSummaryAtom"
  | "trainScheduleDataAtom"
  | "loyaltyProgramDataAtom"
  | "cmsAboutLoyaltyProgramResponseAtom"
  | "loyaltyCardHandleSelectActionAtom"
  | "customerTiersDataAtom"
  | "carriedOverAddonsAtom"
  | "nolCardModeAtom"
  | "nolSelectionAtom"
  | "nolAddedAtom";

export function useRecState<T>(key: TAtomList) {
  const jotaiAtom = getAtomByKey(key) as WritableAtom<T, [T], void>;
  const atomDef = useAtom<T, [T], void>(jotaiAtom);

  useEffect(() => {
    // Load from localStorage first — but only for atoms that are actually
    // persisted (the UPDATE_REC_STATE handler only ever writes whitelisted
    // keys). Skipping the rest avoids 100+ pointless synchronous localStorage
    // reads + JSON parses + date-walks during every page hydration.
    if (whitelistedAtomSet.has(key)) {
      try {
        const storedValue = loadAtomFromLocalStorage<T>(key);
        if (storedValue !== null) {
          atomDef[1](storedValue);
          appStore.set(jotaiAtom, storedValue);
          atomValueCache[key] = storedValue;
        }
      } catch (error) {
        console.warn(`Failed to load stored value for ${key}, clearing corrupted data:`, error);
        // Clear corrupted data
        removeFromLocalStorage(key);
      }
    }

    if (key in bufferMap) {
      atomDef[1](bufferMap[key] as T);
      delete bufferMap[key];
    }
    // No per-hook UPDATE_REC_STATE listener: the module-level handler above
    // already syncs every update into appStore, and useAtom(jotaiAtom) already
    // subscribes this component to appStore. A per-hook listener made every
    // state write fan out to all mounted hooks (O(mounted hooks) microtasks).
  }, []);

  return atomDef;
}

type RecState<K extends keyof RecoilAtomMap> = [
  RecoilAtomMap[K],
  (value: RecoilAtomMap[K]) => void
];

export function useRecStateWithType<K extends keyof RecoilAtomMap>(key: K): RecState<K> {
  return useRecState<RecoilAtomMap[K]>(key);
}

export function updateRecoilState<T>(key: TAtomList, value: T) {
  _eventBus.emit({
    eventName: "UPDATE_REC_STATE",
    data: { key, value },
  });
}

export function updateRecoilStateWithType<K extends keyof RecoilAtomMap>(
  key: K,
  value: RecoilAtomMap[K]
): void {
  updateRecoilState(key, value);
}

export function getRecoilState<T>(key: TAtomList, defaultValue?: T) {
  return new Promise<T>((r) => {
    _eventBus.on<IRecoil, void>({
      eventName: "GET_REC_STATE_RES",
      handler: async ({ data }) => {
        if (data?.key === key) {
          r((data.value as T) ?? (defaultValue as any));
        }
      },
    });
    _eventBus.emit({
      eventName: "GET_REC_STATE",
      data: { key },
    });
  });
}

/**
 * Synchronously get the current value of a recoil state from the buffer map
 * This function can be called from any TypeScript file to get the current state value
 * @param key - The recoil state key to retrieve
 * @param defaultValue - Optional default value if the state is not found
 * @returns The current state value or default value
 */
export function getRecoilStateValue<T>(key: TAtomList, defaultValue?: T): T | undefined {
  if (key in bufferMap) {
    return bufferMap[key] as T;
  }

  if (key in atomValueCache) {
    return atomValueCache[key] as T;
  }

  return defaultValue;
}

export function getRecoilStateValueWithType<K extends keyof RecoilAtomMap>(key: K, defaultValue?: RecoilAtomMap[K]): RecoilAtomMap[K] | undefined {
  return getRecoilStateValue<RecoilAtomMap[K]>(key, defaultValue);
}

if (typeof window !== "undefined") {
  (window as any).__getRecoilStateValue = (key: TAtomList, defaultValue?: unknown) => {
    return getRecoilStateValue(key, defaultValue);
  };
}

export const clearAllWhitelistedAtomsFromStorage = async (): Promise<void> => {
  try {
    whitelistedAtoms.forEach(async (atomKey) => {
      const storageKey = `${STORAGE_PREFIX}${atomKey}`;
      localStorage.removeItem(storageKey);
    });
    console.info("[Recoil] Cleared all whitelisted atoms from localStorage");
  } catch (error) {
    console.warn("Failed to clear whitelisted atoms from localStorage:", error);
  }
};